import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadCommands from './commands';
import loadBlocks from './blocks';
import loadThemePageBlocks from './themePageBlocks';
import { themePageRef } from './consts';

export default grapesjs.plugins.add('gjs-theme-page', (editor, opts) => {
  let options = opts || {};
  const default_commands = {
    theme_page_custom_code: 'theme-page:open-modal',
  };

  const default_refs = {
    themePageRef: themePageRef,
    keyMarketPlaceCustomCode: themePageRef + '__code',
  };

  const default_labels = {
    theme_page_custom_code: 'Theme Page Layouts Custom Code',
    buttonLabel: `<i class="fa fa-plus"></i> Add Theme Page Layout`,
  };

  const default_titles = {
    buttonTitle: 'Add selected section to a canvas',
  };

  let defaults = {
    pfx: 'theme-page',
    blocks: [themePageRef],
    defaultStyle: true,
    label: 'Theme Pages',
    category: 'Advanced',
    refs: default_refs,
    commands: default_commands,
    labels: default_labels,
    titles: default_titles,
    blockthemePageCode: {},
    propsthemePageCode: {},
    placeholderContent: `<span>Insert Theme Page Here</span>`,
    selectArrow: `<div class="gjs-d-s-arrow"></div>`,
    toolbarBtnThemePageCode: {},
    placeholderScript: `<div style="pointer-events: none; padding: 10px;">
      <svg viewBox="0 0 24 24" style="height: 30px; vertical-align: middle;">
        <path d="M13 14h-2v-4h2m0 8h-2v-2h2M1 21h22L12 2 1 21z"></path>
        </svg>
      Theme Page Layout with <i>&lt;script&gt;</i> can't be rendered on the canvas
    </div>`,
    modalTitle: 'Theme Pages',
    codeViewOptions: {},
  };

  for (let name in defaults) {
    if (!(name in options)) options[name] = defaults[name];
  }
  loadComponents(editor, options);
  loadBlocks(editor, options);
  loadThemePageBlocks(editor, options);
  loadCommands(editor, options);
});
